import React from "react";
import { Loader2 } from "lucide-react";

// Xero brand guidance: don't embed the Xero logo inside a custom button — a Xero-blue
// "Connect to Xero" button is the sanctioned DIY option. Hide it once connected.
export const XeroConnectButton = ({ onClick, busy, className = "" }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={busy}
    data-testid="connect-to-xero-btn"
    className={`w-full inline-flex items-center justify-center gap-2 h-11 rounded-md font-semibold text-white transition-[filter] hover:brightness-95 disabled:opacity-70 ${className}`}
    style={{ backgroundColor: "#13B5EA" }}
  >
    {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
    Connect to Xero
  </button>
);

// QuickBooks (Intuit) & Sage aren't live yet — shown as compliant, greyed "Coming soon"
// buttons (Intuit reserves QuickBooks green for the logo, so we don't use brand colour while disabled).
export const ComingSoonConnectButton = ({ provider, dotColor, className = "" }) => (
  <button
    type="button"
    disabled
    aria-disabled="true"
    data-testid={`connect-${provider.toLowerCase().replace(/\s+/g, "-")}-btn`}
    title={`${provider} integration coming soon`}
    className={`w-full inline-flex items-center justify-center gap-2 h-11 rounded-md font-semibold text-slate-400 bg-slate-100 border border-slate-200 cursor-not-allowed ${className}`}
  >
    <span className="h-2.5 w-2.5 rounded-full" style={{ backgroundColor: dotColor }} />
    Connect to {provider}
    <span className="text-[10px] font-bold uppercase tracking-wide text-slate-400 border border-slate-300 rounded-full px-1.5 py-0.5">Soon</span>
  </button>
);

// The full stack of accounting connect buttons (Xero live, QuickBooks + Sage coming soon).
export const AccountingConnectButtons = ({ onConnectXero, busy, showXero = true }) => (
  <div className="space-y-2.5" data-testid="accounting-connect-buttons">
    {showXero && <XeroConnectButton onClick={onConnectXero} busy={busy} />}
    <ComingSoonConnectButton provider="QuickBooks" dotColor="#2CA01C" />
    <ComingSoonConnectButton provider="Sage" dotColor="#00D639" />
  </div>
);

export default AccountingConnectButtons;
